module.exports = __webpack_public_path__ + "img/top_run.d41d30a2.jpg";